import { createContext, useContext, useState, useMemo, useEffect } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";
import localforage from "localforage";
import { useAppServices } from "../hook/services";
import LoadingScreen from "../components/LoadingScreen";

// Material Dashboard 2 React main context
const AppContext = createContext();

// Setting custom name for the context which is visible on react dev tools
AppContext.displayName = "AppContext";

// Material Dashboard 2 React context provider
function AppProvider({ children }) {
  const Service = useAppServices();
  const [app, setApp] = useState({});
  const [loader, setLoader] = useState(true);
  const firstParameter = window.location.pathname.split("/")[1];
  const secondParameter = window.location.pathname.split("/")[2];
  if (firstParameter == "agency") {
    var appId = window.location.pathname.split("/")[3];
  } else if (
    firstParameter == "location" &&
    (secondParameter == "quo" || secondParameter == "servicem8")
  ) {
    var appId = window.location.pathname.split("/")[5];
  } else if (firstParameter == "location" && secondParameter == "twilio") {
    var appId = window.location.pathname.split("/")[5];
  } else if (firstParameter == "location") {
    var appId = window.location.pathname.split("/")[4];
  } else {
    var appId = window.location.pathname.split("/")[2];
  }

  const Update = (updates) => {
    const data = { ...app, ...updates };
    setApp(data);
  };

  const clear = () => setApp({});

  const value = useMemo(() => [app, Update, clear], [app, Update, clear]);

  const getApp = async () => {
    const { response } = await Service.apps.filter({
      query: `appId=${appId}`,
    });
    if (!response) return setLoader(false);

    setApp({ ...response.data });
    localforage.setItem("app", { ...response.data });
    return setLoader(false);
  };

  const onLoad = () => {
    getApp();
  };

  useEffect(onLoad, []);

  if (loader) return <LoadingScreen loadingText={"Loading Data..."} />;

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
}

// Material Dashboard 2 React custom hook for using context
function useAppInfo() {
  return useContext(AppContext) || [];
}

// Typechecking props for the MaterialUIControllerProvider
AppProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export { AppProvider, useAppInfo };
